import PropTypes from "prop-types";
import React from "react";
import { SelectableMenuItem } from "./SelectableMenuItem.js";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { AppFeatures } from "../../constants/featureFlags.js";
import { useFeature } from "../../hooks/index.js";

export const SportCategoryMenuItem = ({ item, ...restProps }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isFavouriteSportsEnabled = useFeature(AppFeatures.FAVOURITE_SPORTS);

  return (
    <SelectableMenuItem
      item={item}
      hasFavouriteFeature={isFavouriteSportsEnabled && isAuthenticated}
      isSportCategory={true}
      {...restProps}
    />
  );
};

SportCategoryMenuItem.propTypes = {
  item: PropTypes.object,
  hasFavouriteFeature: PropTypes.bool
};
